// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","proCon":"RentalPropertyDetail_proCon__IiZSL","cta":"RentalPropertyDetail_cta__Rg0hS","video":"RentalPropertyDetail_video__KLpHc"};